export const FACE = {
  noseWidth: { id: 0, localization: "Ширина носа" },
  noseHeight: { id: 1, localization: "Высота носа" },
  noseLength: { id: 2, localization: "Длина носа" },
  noseBridge: { id: 3, localization: "Переносица" },
  noseTip: { id: 4, localization: "Кончик носа" },
  noseBridgeShift: { id: 5, localization: "Смещение переносицы" },
  browHeight: { id: 6, localization: "Высота бровей" },
  browWidth: { id: 7, localization: "Ширина бровей" },
  cheekboneHeight: { id: 8, localization: "Высота скул" },
  cheekboneWidth: { id: 9, localization: "Ширина скул" },
  cheeksWidth: { id: 10, localization: "Ширина щек" },
  eyes: { id: 11, localization: "Глаза" },
  lips: { id: 12, localization: "Губы" },
  jawWidth: { id: 13, localization: "Ширина челюсти" },
  jawHeight: { id: 14, localization: "Высота челюсти" },
  chinLength: { id: 15, localization: "Длина подбородка" },
  chinPosition: { id: 16, localization: "Положение подбородка" },
  chinWidth: { id: 17, localization: "Ширина подбородка" },
  chinShape: { id: 18, localization: "Форма подбородка" },
  neckWidth: { id: 19, localization: "Ширина шеи" },
};

export const FACE_KEYS = Object.keys(FACE);
